import React from 'react';
import { Box, Stack, Text } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { useStoreActions, useStoreState } from '../../../models/hooks';
import { LogoSlotConfig } from './CompanyLogoType';
import CompanyLogoSlot from './CompanyLogoSlot';

const LOGO_SLOTS: LogoSlotConfig[] = [
  {
    id: 'jobListingLogo',
    title: 'variants.jobListing.title',
    description: 'variants.jobListing.description',
    shapeConstraint: 'square',
    isSquare: true,
  },
  {
    id: 'fullLogo',
    title: 'variants.fullLogo.title',
    description: 'variants.fullLogo.description',
    shapeConstraint: 'square-or-rectangular',
    isSquare: false,
  },
];

export const CompanyLogoVariationsUpload = () => {
  const { t } = useTranslation('uploadCompanyLogo');
  const { user } = useStoreState((s) => s.app);
  const accountId = user?.account;

  const { saveCompanyLogo, getCompanyLogo } = useStoreActions((actions) => actions.administration);

  return (
    <Box p={4}>
      <Text fontSize="xl" fontWeight="bold">
        {t('headerText')}
      </Text>
      <Text color="gray.500" mb={4} fontSize="sm">
        {t('subHeaderText')}
      </Text>

      <Stack spacing={4}>
        {LOGO_SLOTS.map((config) => (
          <CompanyLogoSlot
            key={config.id}
            config={config}
            accountId={accountId}
            saveCompanyLogo={saveCompanyLogo}
            getCompanyLogo={getCompanyLogo}
          />
        ))}
      </Stack>
    </Box>
  );
};
